import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaTwitter } from 'react-icons/fa';
import logo from '../assets/logo.png';
import paynow from '../assets/paynow.PNG';
import zimswitch from '../assets/zimswitch.jpeg';
import visa from '../assets/visa.png';
import mastercard from '../assets/mastercard.jpg';
import innbucks from '../assets/innbucks.png';
import onewallet from '../assets/onewallet.png';
import ecocash from '../assets/ecocash.jpg';

const Footer = () => {
  return (
    <footer className="bg-[#BB0000] text-white mt-10">
      <div className="page-wrap pt-14 pb-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          {/* Brand + socials */}
          <div className="lg:w-[34%] flex flex-col gap-5">
            <Link to="/" className="inline-flex self-start bg-white rounded-md px-3 py-2">
              <img
                src={logo}
                alt="Apertscribe"
                className="h-12 w-auto object-contain"
              />
            </Link>
            <p className="text-sm text-white/90 leading-relaxed max-w-sm">
              Home and office furniture with remarkable quality — trusted across
              Zimbabwe for durable pieces that elevate every space.
            </p>
            <div className="flex items-center gap-4 mt-1">
              <a
                href="https://www.facebook.com/Apertscribe/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full border border-white/50 flex items-center justify-center text-white hover:bg-white hover:text-[#BB0000] transition-colors"
                aria-label="Facebook"
              >
                <FaFacebookF size={14} />
              </a>
              <a
                href="https://www.instagram.com/apertscribe/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full border border-white/50 flex items-center justify-center text-white hover:bg-white hover:text-[#BB0000] transition-colors"
                aria-label="Instagram"
              >
                <FaInstagram size={14} />
              </a>
              <a
                href="https://twitter.com/apertscribe"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full border border-white/50 flex items-center justify-center text-white hover:bg-white hover:text-[#BB0000] transition-colors"
                aria-label="Twitter"
              >
                <FaTwitter size={14} />
              </a>
            </div>
          </div>

          {/* Link columns */}
          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h3 className="text-sm font-semibold mb-4">Shop</h3>
              <ul className="space-y-3 text-sm text-white/90">
                <li><Link to="/store" className="hover:text-white transition-colors">All Products</Link></li>
                <li><Link to="/store?category=Office" className="hover:text-white transition-colors">Office</Link></li>
                <li><Link to="/store?category=Lounge" className="hover:text-white transition-colors">Lounge</Link></li>
                <li><Link to="/store?category=Bedroom" className="hover:text-white transition-colors">Bedroom</Link></li>
                <li><Link to="/store?category=Kitchen" className="hover:text-white transition-colors">Kitchen</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold mb-4">Company</h3>
              <ul className="space-y-3 text-sm text-white/90">
                <li><Link to="/AboutUs" className="hover:text-white transition-colors">About Us</Link></li>
                <li><Link to="/Contact" className="hover:text-white transition-colors">Contact</Link></li>
                <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
                <li><Link to="/store?category=Electricals" className="hover:text-white transition-colors">Electricals</Link></li>
                <li><Link to="/store?category=Dining" className="hover:text-white transition-colors">Dining</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold mb-4">Support</h3>
              <ul className="space-y-3 text-sm text-white/90">
                <li><a href="tel:+263719100058" className="hover:text-white transition-colors">+263 719 100 058</a></li>
                <li><a href="tel:+263773117987" className="hover:text-white transition-colors">+263 773 117 987</a></li>
                <li><a href="mailto:sales@apertscribe.co.zw" className="hover:text-white transition-colors">sales@apertscribe.co.zw</a></li>
                <li><a href="mailto:customercare@apertscribe.co.zw" className="hover:text-white transition-colors">customercare@apertscribe.co.zw</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Payment methods */}
      <div className="border-t border-white/20">
        <div className="page-wrap py-5 flex flex-wrap items-center justify-center gap-3">
          {[paynow, zimswitch, visa, mastercard, innbucks, onewallet, ecocash].map((src, i) => (
            <img key={i} src={src} alt="" className="h-9 w-auto object-contain rounded-sm bg-white p-1" />
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/20">
        <div className="page-wrap py-4 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-xs text-white/80">
          <p>Copyright © {new Date().getFullYear()} Apertscribe. All rights reserved.</p>
          <div className="flex gap-6">
            <span className="hover:text-white cursor-default">Terms & Conditions</span>
            <span className="hover:text-white cursor-default">Privacy Policy</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
